<template>
  <!--  v-if="find_stores_by_brand_id(brand._id).length" -->
  <div class="col-grid-box col-xl-3 col-lg-4 col-sm-6">
    <div
      class="product-box"
      :class="{ 'show-quickview': openQuickview }"
      @mouseleave="hideQuickview()"
    >
      <div class="img-box" @click="showModal(brand)">
        <a href="javascript:void(0)" class="image link-change">
          <div
            class="bg-size"
            v-if="brand.goorder_background_image"
            v-bind:style="{
              'background-image': `url(${brand.goorder_background_image})`,
            }"
          ></div>
          <div
            v-else
            :style="{ 'background-image': 'url(/images/no-image.jpg)' }"
            class="bg-size"
          ></div>
        </a>
        <div class="brand-label" v-if="brand.company_logo">
          <img
            :src="brandLogoPath"
            @error="brandLogoPath = brand.company_logo"
            class="img-fluid"
            alt="brand"
          />
        </div>
        <div
          v-if="brand.tag != 'no_tag'"
          class="offer-label"
          :class="brand.tag"
        >
          <span>{{ _T_DB(brand, 'tag') }}</span>
        </div>
      </div>
      <div class="product-content">
        <a href="javascript:void(0)" @click="showModal(brand)">
          <h4 :title="brand.company_name" @click="openStore(brand)">
            {{ _T_DB(brand, 'company_name') }}
          </h4>
        </a>
        <ul class="location-detail" @click="showModal(brand)">
          <li>
            <div class="svg secondary">
              <svg width="15" height="15" fill="none">
                <use xlink:href="#marker" />
              </svg>
            </div>
            <div class="detail">
              <span>
                <!-- {{
              _T('Sheikh Zayed Rd - Dubai -uae')
            }} -->
                {{ storeAddress(brand._id) }}
              </span>
            </div>
          </li>
          <li class="d-md-none">
            <span data-toggle="modal" @click="showModal(brand)"
              >{{ getStoreCount(brand._id) }} {{ _T('outlets near you') }}
              <img
                src="/images/svg/global/arrow-gray.svg"
                class="img-fluid"
                alt=""
            /></span>
          </li>
        </ul>
        <ul class="offer-section" @click="showModal(brand)">
          <li v-if="discount_value">
            <div class="svg tertiary">
              <svg width="15" height="15" fill="none">
                <use xlink:href="#percentRound" />
              </svg>
            </div>
            <div class="detail">
              <span>
                {{ discount_value }} {{ _T('off') }} |
                {{ _T_DB(brandDiscount, 'name') }}
              </span>
            </div>
          </li>
          <li v-else>
            <div class="detail">
              <span>
                {{ _T('No offer available') }}
              </span>
            </div>
          </li>
        </ul>
        <div class="quick-view text-left">
          <a data-toggle="modal" @click="showModal(brand)"
            >{{ getStoreCount(brand._id) }} {{ _T('outlets') }}</a
          >
          <a
            href="javascript:void(0)"
            class="float-right d-sm-none d-lg-inline-block"
            @mouseover="showQuickview(brand._id)"
          >
            {{ _T('Quick view') }}
          </a>
        </div>
      </div>
      <Quickview></Quickview>
    </div>
  </div>
</template>
<script>
import Quickview from './Quickview'
import * as CONST from '@/constants'
import { mapGetters } from 'vuex'
import Availability from '@/helpers/Availability'

export default {
  name: 'BrandTile',
  props: {
    brand: {
      type: Object,
      default () {
        return {}
      },
    },
  },
  components: {
    Quickview,
  },
  computed: {
    ...mapGetters([
      'siteDomain',
      'brandWiseStores',
      '_T',
      '_T_DB',
      'quick_view_menu_items_prepared',
      'getDeliverableStoresForBrand',
      'quick_view_store_categories',
      'brandStoreRoute',
      'selectedDa',
      'find_stores_by_brand_id',
      'brandStoreParams',
      'brandStoreRoute',
      'getElementByAreaId',
      'customizationLocal',
      'set_website_slug',
      'currentDeliveryArea',
    ]),
    brandDiscount () {
      const discounts = this.$store.getters.find_root_discount_by_brand_id(
        this.brand._id
      )
      if (discounts) {
        let valueDiscount = { value: 0 }
        let percentDiscount = { rate: 0 }
        let fixedDiscount = { value: 0 }
        if (!discounts || discounts.length == 0) {
          return undefined
        }

        discounts.forEach(discount => {
          if (discount.type == CONST.DISCOUNT_TYPE_VALUE) {
            if (valueDiscount.value < discount.value) {
              valueDiscount = discount
            }
          } else if (discount.type == CONST.DISCOUNT_TYPE_PERCENTAGE) {
            if (percentDiscount.rate < discount.rate) {
              percentDiscount = discount
            }
          } else if (discount.type == CONST.DISCOUNT_TYPE_FIXED_PRICE) {
            if (fixedDiscount.value < discount.value) {
              fixedDiscount = discount
            }
          }
        })

        if (fixedDiscount.value > valueDiscount.value) {
          valueDiscount = fixedDiscount
        }

        if (valueDiscount.value) {
          return valueDiscount
        } else {
          return percentDiscount
        }
      }
      return null
    },
    discount_value () {
      if (this.brandDiscount) {
        let discountAvailable = Availability.available(
          this.brandDiscount,
          Intl.DateTimeFormat().resolvedOptions().timeZone
        )
        if (discountAvailable) {
          if (this.brandDiscount.type == CONST.DISCOUNT_TYPE_VALUE) {
            return this.brand.currency + ' ' + this.brandDiscount.value
          } else if (
            this.brandDiscount.type == CONST.DISCOUNT_TYPE_PERCENTAGE
          ) {
            return this.brandDiscount.rate + '%'
          } else if (
            this.brandDiscount.type == CONST.DISCOUNT_TYPE_FIXED_PRICE
          ) {
            return this.brand.currency + ' ' + this.brandDiscount.value
          }
        } else {
          return ''
        }
      }
      return ''
    },
  },
  watch: {
    brand (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.getImage()
        })
      }
    },
  },
  data () {
    return {
      openQuickview: false,
      brandLogoPath: '',
    }
  },
  methods: {
    showModal (brand) {
      this.$store.commit('SET_CURRENT_BRAND', brand)
      this.$store.commit('IS_STORE_BRAND', false)
      this.$store.commit('SET_CURRENT_STORE', this.brandWiseStores[0])
      this.$store.commit('SET_SELECTED_BRAND', this.brand._id)
      if (this.brandWiseStores.length > 1) {
        this.$bvModal.show('storepicker-id')
      } else {
        this.$router.replace({
          name: this.siteDomain + '_store_page',
          params: {
            brand_id: this.set_website_slug(brand),
            store_id: this.set_website_slug(this.brandWiseStores[0]),
            delivery_area: this.currentDeliveryArea,
          },
        })
      }
    },
    hideQuickview () {
      this.openQuickview = false
    },
    showQuickview (brandId) {
      let params = { brand_id: false, store_id: false }
      this.$store.commit('SET_SELECTED_BRAND', this.brand._id)
      let quickView = { items: false, categories: false, selected_cat: false, data: params }
      this.$store.commit('QUICK_VIEW', quickView)
      if (this.brandWiseStores.length) {
        params = {
          brand_id: brandId,
          store_id: this.brandWiseStores[0]._id,
        }
        this.$store
          .dispatch('load_quick_view_menu_items', params, { root: true })
          .then(() => {
            quickView.items = this.quick_view_menu_items_prepared(params)
            quickView.categories = this.quick_view_store_categories(params)
            quickView.data = params
            quickView.selected_cat = quickView.categories
              ? quickView.items.filter(
                  item => item.category === quickView.categories[0]._id
                )
              : false
            this.$store.commit('QUICK_VIEW', quickView)
          })
      }
      this.openQuickview = true
    },
    openStore (brand) {
      this.$store.commit('SET_SELECTED_BRAND', brand._id)
    },
    brandStore (brandId) {
      this.$store.commit('SET_SELECTED_BRAND', brandId)
    },
    storeAddress (brand_id) {
      var stores = this.getDeliverableStoresForBrand(brand_id)
      if (stores.length == 0) {
        if (this.selectedDa) {
          return (
            this.getElementByAreaId(this.selectedDa, 2) +
            '-' +
            this.getElementByAreaId(this.selectedDa, 1)
          )
        }
        return 'N/A'
      } else {
        return stores.length > 1 ? 'Multiple Locations' : stores[0].address
      }
    },
    getStoreCount (brand_id) {
      let brandInfo = this.getDeliverableStoresForBrand(brand_id)
      return brandInfo ? brandInfo.length : 1
    },
    getImage () {
      if (this.brand && this.brand.company_logo) {
        this.brandLogoPath = ''
        let url = this.brand.company_logo.split('company_logos/')
        this.brandLogoPath = url[0] + 'company_logos/large/' + url[1]
      }
    },
  },
  beforeDestroy () {
    this.brandLogoPath = ''
  },
}
</script>
<style lang="scss">

.col-grid-box {
  &:nth-child(4n + 3),
  &:nth-child(4n + 4) {
    .quick-view-modal {
      left: unset;
      right: 70%;
      padding-left: 0;
      padding-right: $px30;
    }
    .product-box {
      &.show-quickview {
        .quick-view-modal {
          left: unset;
          right: 100%;
        }
      }
    }
  }
}
.product-box {
  background: $white;
  border: $px1 solid rgba(var(--color-dark-border-source), 0.44);
  border-radius: 0.625rem;
  padding: 0.5rem;
  margin-bottom: 4.063rem;
  position: relative;
  &.closed {
    pointer-events: none;
    cursor: not-allowed;
  }
  .img-box {
    position: relative;
    .image {
      border-radius: 0.625rem;
      overflow: hidden;
      .bg-size {
        background-size: cover;
        background-position: center;
        border-radius: 0.625rem;
      }
    }
    .tray-label {
      position: absolute;
      right: 5.5rem;
      top: 0.75rem;
      background-color: $white;
      width: 2.375rem;
      height: 2.375rem;
      border-radius: 0.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
      &.only {
        right: 0.75rem;
      }
    }
    .brand-label {
      position: absolute;
      width: 6rem;
      height: 3rem;
      background-color: $white;
      border-radius: $px10;
      top: 0.375rem;
      left: 0.375rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: $px3 solid rgba(var(--color-dark-border-source), 0.9);
      padding: $px2;
      overflow: hidden;
      .bg-logo-size {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 100%;
      }
    }
    .offer-label {
      width: 6.25rem;
      height: 2.375rem;
      border-radius: 0.25rem;
      position: absolute;
      right: -1.125rem;
      top: 0.75rem;
      background-color: $color-primary;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-weight: 600;
        font-size: 0.75rem;
        line-height: 0.938rem;
        color: white;
        text-transform: uppercase;
        letter-spacing: 0.031rem;
      }
    }
    .busy-label {
      position: absolute;
      left: 0.938rem;
      bottom: 0.938rem;
      background: $color-primary;
      border-radius: 1.313rem;
      display: flex;
      align-items: center;
      padding: 0.25rem 0.938rem;
      justify-content: center;
      img {
        margin-right: 0.375rem;
      }
      h6 {
        color: white;
        margin-bottom: 0;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 0.875rem;
        line-height: 1.063rem;
      }
      &.busy-white {
        background: $white;
        padding: 0.25rem 0.625rem;
        svg {
          height: 0.75rem !important;
          path {
            fill: $color-secondary;
          }
        }
        h6 {
          color: $color-secondary;
          font-weight: normal;
          font-size: 0.813rem;
          line-height: 1rem;
          margin-left: 0.25rem;
          text-transform: lowercase;
        }
      }
    }
    &.new {
      .offer-label {
        background-color: $warning-color;
      }
    }
    &.promoted {
      .offer-label {
        background-color: $color-tertiary;
      }
    }
    &.closed {
      overflow: hidden;
      position: relative;
      .image {
        filter: grayscale(1);
        .bg-size {
          filter: grayscale(1);
        }
      }
      .offer-label {
        transform: rotate(45deg);
        width: 9.375rem;
        right: -2.25rem;
        span {
          text-transform: capitalize;
        }
      }
    }
  }
  .product-content {
    padding: 0.75rem 0.5rem;
    position: relative;
    .point-label {
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 100%;
      position: absolute;
      top: -1.5rem;
      right: 0.5rem;
      background-color: white;
      padding: 0.125rem;
      label {
        background: linear-gradient(
          217.57deg,
          $color-secondary 42.7%,
          $color-primary 155.02%
        );
        border: 2px solid rgba(var(--color-white-source), 0.25);
        width: 100%;
        height: 100%;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      span {
        position: absolute;
        bottom: -1.063rem;
        right: 1.063rem;
        font-weight: 600;
        font-size: 0.75rem;
        line-height: 0.938rem;
        color: $font-color;
      }
    }
    h4 {
      font-size: calc(0.875rem + (18 - 14) * ((100vw - 20rem) / (1920 - 320)));
      max-width: 14.225rem;
      font-weight: bold;
      text-transform: capitalize;
      margin-bottom: 0;
      color: $font-color;
      -webkit-line-clamp: 3;
      text-overflow: ellipsis;
      display: -webkit-box;
      overflow: hidden;
      white-space: normal;
      -webkit-box-orient: vertical;
    }
    .location-detail {
      margin-top: 0.625rem;
      &:focus {
        outline: none;
      }
      li {
        display: flex;
        align-items: center;
        .svg {
          margin-right: 0.625rem;
          line-height: 1rem;
          &.warning {
            svg {
              fill: $warning-color;
              path {
                fill: $warning-color;
              }
            }
          }
          &.dark {
            svg {
              fill: $black;
              path {
                fill: $black;
              }
            }
          }
          &.secondary {
            svg {
              fill: $color-secondary;
              path {
                fill: $color-secondary;
              }
            }
          }
        }
        .detail {
          display: flex;
          align-items: center;
          span {
            font-size: 0.813rem;
            line-height: 1rem;
            color: $font-color;
            max-width: 13.15rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            + span {
              margin-left: 0.5rem;
              padding-left: 0.5rem;
              position: relative;
              &:after {
                content: '';
                position: absolute;
                width: 0.25rem;
                height: 0.25rem;
                background: $light-font;
                border-radius: 100%;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
        }
        + li {
          margin-top: 0.25rem;
        }
        &:last-child {
          margin-bottom: -0.25rem;
        }
      }
    }
    .offer-section {
      padding-top: 0.625rem;
      margin-top: 0.875rem;
      border-top: $px1 solid $light-border;
      li {
        display: flex;
        align-items: center;
        .svg {
          margin-right: 0.625rem;
          line-height: 1rem;
          &.tertiary {
            svg {
              fill: $color-tertiary;
              path {
                fill: $color-tertiary;
              }
            }
          }
        }
        .detail {
          display: flex;
          align-items: center;
          span {
            font-size: 0.813rem;
            line-height: 1rem;
            font-weight: 600;
            color: $color-tertiary;
            + span {
              margin-left: 0.5rem;
              padding-left: 0.5rem;
              position: relative;
              &:after {
                content: '';
                position: absolute;
                width: 0.25rem;
                height: 0.25rem;
                background: $light-font;
                border-radius: 100%;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
        }
        + li {
          margin-top: 0.25rem;
        }
        &:last-child {
          margin-bottom: -0.25rem;
        }
      }
    }
    .quick-view {
      text-align: center;
      padding-top: 0.75rem;
      border-top: 1px solid $light-border;
      margin-top: 0.875rem;
      margin-bottom: -0.313rem;
      display: none;
      transition: all 0.5s ease;
      a {
        text-transform: capitalize;
        font-weight: 600;
        font-size: 0.875rem;
        line-height: 1.375rem;
        letter-spacing: 0.031rem;
        cursor: pointer;
      }
    }
    &.wo-point {
      h4 {
        max-width: 100%;
      }
      .point-label {
        display: none;
      }
    }
  }
  &:hover {
    margin-bottom: 1.313rem;
    box-shadow: 0px 8px 30px rgba($black, 0.15);
    .product-content {
      .quick-view {
        display: block;
        transition: all 0.5s ease;
      }
    }
  }
  &.show-quickview {
    .quick-view-modal {
      opacity: 1;
      visibility: visible;
      left: 100%;
      transition: all 0.5s ease;
      &.left-part {
        left: unset;
        right: 100%;
      }
    }
  }
  &.wo-quick {
    &:hover {
      margin-bottom: 4.063rem;
      .product-content {
        .quick-view {
          display: none;
        }
      }
    }
  }
}
.bg-size {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: block;
}
@media (max-width: 1199px) {
  .product-box {
    margin-bottom: $px55;
    &:hover {
      margin-bottom: $px11;
    }
  }
  .col-grid-box {
    &:nth-child(3),
    &:nth-child(6),
    &:nth-child(9) {
      .quick-view-modal {
        left: unset;
        right: 70%;
        padding-left: 0;
        padding-right: $px30;
      }
      .product-box {
        &.show-quickview {
          .quick-view-modal {
            left: unset;
            right: 100%;
          }
        }
      }
    }
    &:nth-child(4),
    &:nth-child(7),
    &:nth-child(8) {
      .quick-view-modal {
        left: 70%;
        right: unset;
        padding-left: $px30;
        padding-right: 0;
      }
      .product-box {
        &.show-quickview {
          .quick-view-modal {
            right: unset;
            left: 100%;
          }
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .product-box {
    .product-content {
      h4 {
        max-width: $px225;
      }
    }
  }
}
@media (max-width: 767px) {
  .product-box {
    margin-bottom: $px30;
    .img-box {
      width: 100%;
      .brand-label {
        display: none;
      }
    }
    .product-content {
      .quick-view {
        display: none;
      }
      .location-detail {
        li {
          .detail {
            span {
              max-width: $px120;
            }
          }
        }
      }
      h4 {
        max-width: $px145;
      }
    }
    &:hover {
      margin-bottom: $px30;
      .product-content {
        .quick-view {
          display: none;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .product-box {
    border: none;
    padding: 0;
    display: flex;
    align-items: flex-start;
    .img-box {
      width: 28%;
      position: relative;
      .offer-label {
        height: $px22;
        right: 0;
        left: 0;
        width: 100%;
        bottom: -$px1;
        top: unset;
        border-radius: 0;
        span {
          text-transform: capitalize;
        }
      }
      .brand-label {
        width: $px54;
        height: $px54;
        img {
          width: 64%;
        }
      }
      .tray-label,
      .busy-label {
        display: none;
      }
      &.closed {
        .offer-label {
          width: 100%;
          transform: rotate(0);
          right: 0;
        }
      }
    }
    .product-content {
      width: 68%;
      margin-left: auto;
      padding: 0;
      h4 {
        max-width: 100%;
      }
      .location-detail {
        margin-top: $px4;
        li {
          .detail {
            span {
              overflow: unset;
              max-width: 100%;
              white-space: normal;
            }
          }
        }
      }
      .point-label {
        display: none;
        width: $px50;
        height: $px50;
      }
      .quick-view {
        padding-top: $px8;
        display: none;
      }
    }
    &:hover {
      margin-bottom: $px30;
      box-shadow: none;
      .product-content {
        .quick-view {
          display: none;
        }
      }
    }
  }
}
@media (max-width: 360px) {
  .product-box {
    .product-content {
      .location-detail {
        li {
          .detail {
            span {
              max-width: $px140;
            }
          }
        }
      }
    }
  }
}
.body-rtl {
  ul.location-detail {
    padding-right: 0;
    padding-left: unset;
    li {
      .svg {
        margin-left: 0.625rem;
        margin-right: unset;
      }
      span {
        text-align: right;
        }
    }
  }
  .product-box {
    .product-content {
      h4 {
        text-align: right;
        padding-right: 10px;
      }
      ul {
        padding-right: 0;
        padding-left: unset;
        @media (max-width: 575px) {
          li {
             &:last-child {
              padding-right:14px;
            } 
          }
        }
      }
      .offer-section {
        li {
          .svg {
            margin-left: 0.625rem;
            margin-right: unset;
          }
          @media (max-width: 575px) {
            span {
              text-align: right;
            }
          }
        }
        
      }
    }
  }
  .col-grid-box {
    &:nth-child(4n + 3),
    &:nth-child(4n + 4) {
      .quick-view-modal {
        right: unset;
        left: 70%;
        padding-right: 0;
        padding-left: $px30;
      }
      .product-box {
        &.show-quickview {
          .quick-view-modal {
            right: unset;
            left: 100%;
          }
        }
      }
    }
  }
}
</style>
